export const POP_CONFETTI = 'POP_CONFETTI';
export const RESET_CONFETTI_REDUCER = 'RESET_CONFETTI_REDUCER';